import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { metrics, TheWestSection } from '@news-mono/component-library'
import { StaticRoutes, Topic } from '@news-mono/web-common'
import { layout } from '../App.routing'
import { getPuzzleRoute } from './puzzles/getPuzzleRoute'
import { getTopicSponsor } from './topic/get-topic-sponsor'
const socialImage = require('./topic/custom/assets/puzzles/socialImage.jpg')

export const puzzles: StaticRoutes<TheWestSection> = {
    '/puzzles': ({ getAdTargeting, store, config }) => {
        if (
            !isFeatureEnabled(
                toFeatureState(store.getState().toggles),
                'puzzles',
            )
        ) {
            return null
        }

        const canonicalUrl = config.publicUrl + '/puzzles'
        const renditionType = store.getState().render.renditionType
        const topic: Topic = {
            id: 'puzzles',
            metadata: {},
            title: 'Puzzles',
            seoTitle: 'Fun Daily Online Puzzles | The West Australian',
            seoDescription: `Put your brain to the test and challenge yourself to The West Australian's daily Word Search, Sudoku, Crossword and Target puzzles. Play now.`,
        }
        const getSocialImageMeta = [
            {
                property: 'og:image',
                content: socialImage,
            },
            { name: 'twitter:image', content: socialImage },
            {
                property: 'og:image:height',
                content: '643',
            },
            {
                property: 'og:image:width',
                content: '1224',
            },
            {
                property: 'og:description',
                content: topic.seoDescription,
            },
            {
                property: 'twitter:description',
                content: topic.seoDescription,
            },
        ]

        return {
            kind: 'page',
            heading: 'Puzzles',
            pageType: 'static',
            hideHeading: true,
            refreshOnInactive: false,
            pageMeta: {
                title: topic.title,
                description: topic.seoDescription,
                seoTitle: topic.seoTitle,
                seoDescription: topic.seoDescription,
                link: [{ rel: 'canonical', href: canonicalUrl }],
                meta: getSocialImageMeta,
            },
            adTargeting: getAdTargeting('home', 'default', topic),
            section: 'default',
            compositions: [
                layout.composition({
                    type: 'athena',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        elementType: 'div',
                        sidebarOptions: 'visibleMobile',
                    },
                    contentAreas: {
                        main:
                            renditionType !== 'app'
                                ? [
                                      layout.component({
                                          type: 'breadcrumb',
                                          props: {
                                              topic,
                                              sponsor: getTopicSponsor(topic),
                                              enableHeaderTag: true,
                                              verticalSpacing: 'lg',
                                          },
                                      }),
                                      layout.component({
                                          type: 'puzzles-listing',
                                          requiresAccess: {
                                              level: 'anonymous',
                                              notAuthorized: layout.composition(
                                                  {
                                                      type: 'thor',
                                                      props: {
                                                          containerWidth:
                                                              metrics.thewest
                                                                  .siteMetrics
                                                                  .mainContentWidth,
                                                          horizontalGutters:
                                                              true,
                                                          hasBackgroundFill:
                                                              true,
                                                          stretchSelf: true,
                                                      },
                                                      contentAreas: {
                                                          main: [
                                                              layout.component({
                                                                  type: 'breachscreen',
                                                                  props: {
                                                                      title: 'Subscribe to access puzzles',
                                                                      breachDeal:
                                                                          'Puzzles',
                                                                      breachCreativeName:
                                                                          'Puzzles',
                                                                      terms: 'Some terms',
                                                                  },
                                                              }),
                                                          ],
                                                      },
                                                  },
                                              ),
                                          },
                                          props: {},
                                      }),
                                      layout.component({
                                          type: 'ad-unit',
                                          props: {
                                              noticePosition: 'below-center',
                                              padding: [
                                                  0,
                                                  0,
                                                  metrics.thewest.margins.md,
                                                  0,
                                              ],
                                              slot: {
                                                  id: 'mobile-mrec',
                                                  size: 'mobileMrec',
                                                  pageType: 'static',
                                              },
                                              adType: 'inline',
                                          },
                                      }),
                                      layout.component({
                                          type: 'lima',
                                          props: {
                                              verticalSpacing: 'xl',
                                              fontScale: 1.2,
                                              fixedRatios: ['16:9'],
                                              hasBackground: true,
                                              teaserMode: {
                                                  initial: 'visible',
                                                  xs: 'visible',
                                                  sm: 'hidden',
                                                  md: 'hidden',
                                              },
                                              isSponsoredCollection: true,
                                              hasSeparator: false,
                                              hasBorder: false,
                                              initialColumns: 1,
                                              intermediateColumns: 2,
                                              finalColumns: 2,
                                              cardLayout: [
                                                  ['teaserWithBackground'],
                                                  ['teaserWithBackground'],
                                                  ['teaserWithBackground'],
                                                  ['teaserWithBackground'],
                                              ],
                                              cardOrientation: {
                                                  type: 'Landscape-Portrait',
                                              },
                                              dataDefinitionArgs: {
                                                  type: 'listing',
                                                  topics: [
                                                      'entertainment/competitions',
                                                  ],
                                                  includeSubTopics: false,
                                                  paging: {
                                                      page: 0,
                                                      pageSize: 4,
                                                  },
                                              },
                                              sectionHeader: {
                                                  heading: 'Competitions',
                                                  headingUrl:
                                                      '/entertainment/competitions',
                                                  section: 'entertainment',
                                              },
                                          },
                                      }),
                                  ]
                                : [
                                      layout.component({
                                          type: 'puzzles-listing',
                                          requiresAccess: {
                                              level: 'anonymous',
                                              notAuthorized: layout.composition(
                                                  {
                                                      type: 'thor',
                                                      props: {
                                                          containerWidth:
                                                              metrics.thewest
                                                                  .siteMetrics
                                                                  .mainContentWidth,
                                                          horizontalGutters:
                                                              true,
                                                          hasBackgroundFill:
                                                              true,
                                                          stretchSelf: true,
                                                      },
                                                      contentAreas: {
                                                          main: [
                                                              layout.component({
                                                                  type: 'breachscreen',
                                                                  props: {
                                                                      title: 'Subscribe to access puzzles',
                                                                      breachDeal:
                                                                          'Puzzles',
                                                                      breachCreativeName:
                                                                          'Puzzles',
                                                                      terms: 'Some terms',
                                                                  },
                                                              }),
                                                          ],
                                                      },
                                                  },
                                              ),
                                          },
                                          props: {},
                                      }),
                                  ],

                        // SIDEBAR
                        sidebar:
                            renditionType !== 'app'
                                ? [
                                      layout.component({
                                          type: 'ad-unit',
                                          props: {
                                              noticePosition: 'below-center',
                                              padding: [
                                                  0,
                                                  0,
                                                  metrics.thewest.margins.md,
                                                  0,
                                              ],
                                              slot: {
                                                  id: 'sidebar-top',
                                                  size: 'desktopMrecHalfPage',
                                                  pageType: 'static',
                                              },
                                              adType: 'inline',
                                          },
                                      }),
                                      layout.nestedComposition({
                                          type: 'box',
                                          props: {
                                              stickyOffset: 350,
                                              fillContainer: true,
                                          },
                                          contentAreas: {
                                              main: [
                                                  layout.component({
                                                      type: 'ad-unit',
                                                      props: {
                                                          noticePosition:
                                                              'below-center',
                                                          padding: [
                                                              0,
                                                              0,
                                                              metrics.thewest
                                                                  .margins.md,
                                                              0,
                                                          ],
                                                          slot: {
                                                              id: 'sidebar-middle',
                                                              size: 'desktopMrec',
                                                              pageType:
                                                                  'static',
                                                          },
                                                          adType: 'inline',
                                                      },
                                                  }),

                                                  layout.component({
                                                      type: 'juliet',
                                                      props: {
                                                          cardType: {
                                                              type: 'landscape',
                                                              format: 'landscape-smallImage',
                                                          },
                                                          removeHorizontalGutters:
                                                              true,
                                                          kickerMode: 'hidden',
                                                          contentIsTangential:
                                                              true,
                                                          sectionHeader: {
                                                              heading:
                                                                  'Top Stories',
                                                          },
                                                          dataDefinitionArgs: {
                                                              type: 'curation',
                                                              name: 'home',
                                                              offset: 0,
                                                              pageSize: 3,
                                                          },
                                                      },
                                                  }),
                                              ],
                                          },
                                      }),
                                  ]
                                : [],
                    },
                }),
            ],
        }
    },

    '/puzzles/sudoku': getPuzzleRoute(
        {
            id: 'puzzles/sudoku',
            title: 'Sudoku',
            seoTitle: 'Sudoku - Puzzles',
            seoDescription:
                "Practice your problem solving skills with The West Australian's latest Sudoku challenge or play our Crossword, Word Search or Target puzzles now.",
            metadata: {},
            parent: {
                id: 'puzzles',
                title: 'Puzzles',
                seoTitle: 'Puzzles',
                metadata: {},
            },
        },
        'auspac-per610-sud200',
        'https://cdn2.amuselabs.com/pmm/date-picker?set=auspac-per610-sud200&embed=1',
    ),
    '/puzzles/word-search': getPuzzleRoute(
        {
            id: 'puzzles/word-search',
            title: 'Word Search',
            seoTitle: 'Word Search - Puzzles',
            seoDescription:
                "Put your word finding skills to the test with The West Australian's latest Word Search challenge or play our Crossword, Sudoku or Target puzzles now.",
            metadata: {},
            parent: {
                id: 'puzzles',
                title: 'Puzzles',
                seoTitle: 'Puzzles',
                metadata: {},
            },
        },
        'auspac-per610-wf15',
        'https://cdn2.amuselabs.com/pmm/date-picker?set=auspac-per610-wf15&embed=1',
    ),
    '/puzzles/crossword': getPuzzleRoute(
        {
            id: 'puzzles/crossword',
            title: 'Crossword',
            seoTitle: 'Crossword - Puzzles',
            seoDescription:
                "Solve The West Australian's latest Quick and Cryptic Crosswords, access past challenges or play our Word Search, Sudoku or Target puzzles now.",
            metadata: {},
            parent: {
                id: 'puzzles',
                title: 'Puzzles',
                seoTitle: 'Puzzles',
                metadata: {},
            },
        },
        'auspac-per610-nat140',
        'https://cdn2.amuselabs.com/pmm/date-picker?set=auspac-per610-nat140&embed=1',
    ),
    '/puzzles/target': getPuzzleRoute(
        {
            id: 'puzzles/target',
            title: 'Target',
            seoTitle: 'Target (Jumble Word) - Puzzles',
            seoDescription:
                "How many words can you make from these letters? Try The West Australian's Target challenge or play our Crossword, Word Search or Sudoku puzzles now.",
            metadata: {},
            parent: {
                id: 'puzzles',
                title: 'Puzzles',
                seoTitle: 'Puzzles',
                metadata: {},
            },
        },
        '',
        'https://jumble.auspacmedia.com.au/listgames/west-australian',
    ),
}
